const bag__ = 'bag__1';
const deserialize = () => 
    window.localStorage.getItem(bag__) && JSON.parse(window.localStorage.getItem(bag__)) || [];
const serialize = (bag) => 
    window.localStorage.setItem(bag__, JSON.stringify(bag));
    
export default {
    get: function() {return deserialize();},
    set: function(value) {serialize(value);}
};